import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { tokenStore } from '@/auth/token';
import { z } from 'zod';
import { APP_ROUTES } from '@/const/routes';

const UAEPassLoginPage = lazy(() =>
  import('@/features/auth/login/UAEPassLoginPage').then((m) => ({ default: m.UAEPassLoginPage })),
);

const loginSearchSchema = z.object({
  reason: z.string().optional(),
});

export const Route = createFileRoute('/login-uaepass')({
  validateSearch: loginSearchSchema,
  beforeLoad: () => {
    if (tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.app.index });
    }
  },
  component: () => (
    <Suspense>
      <UAEPassLoginPage />
    </Suspense>
  ),
});
